module.exports = __webpack_public_path__ + "img/qr-slide-2.8f150c37.png";